import { ImagePreview } from './ImagePreview';
import { ShowImagePreviewModalProps } from './types';
import { modal, ModalSize, ModalTemplate } from '@ardoq/modal';
import { useImagePreview } from './useImagePreview';

const ImagePreviewModal = ({
  title = 'Image preview',
  closeButtonText = 'Close',
  errorMessages,
  onClose,
  ...imagePreviewProps
}: ShowImagePreviewModalProps & {
  onClose: VoidFunction;
}) => {
  const { commands, state } = useImagePreview(errorMessages);

  return (
    <ModalTemplate
      headerText={title}
      onCloseButtonClick={onClose}
      modalSize={ModalSize.L}
      onPrimaryButtonClick={onClose}
      primaryButtonText={closeButtonText}
    >
      <ImagePreview {...imagePreviewProps} {...state} commands={commands} />
    </ModalTemplate>
  );
};

export const showImagePreviewModal = ({
  ...config
}: ShowImagePreviewModalProps) => {
  return modal<void>(
    resolve => <ImagePreviewModal onClose={resolve} {...config} />,
    {}
  );
};

export type ShowImagePreviewModal = typeof showImagePreviewModal;
